import Row, { RowProps } from 'antd/es/row';
import { clsx } from 'clsx';
import React from 'react';

import s from './AntRow.module.less';

export const AntRow = React.forwardRef<HTMLDivElement, RowProps>((props, ref) => {
  const { ...rest } = props;

  return <Row {...rest} className={clsx(rest.className, s.row)} ref={ref} />;
});

AntRow.displayName = 'AntRow';
